export const SET_ADJUSTMENTS = 'SET_ADJUSTMENTS'



// WEBPACK FOOTER //
// ./src/types/adjustments.js